const investmentMoodPointsDataset =[
  { amountLevel: 1, amount: 1000, moodPoints: 200},
  { amountLevel: 2, amount: 5000, moodPoints: 500},
  { amountLevel: 3, amount: 10000, moodPoints: 1000},
  { amountLevel: 4, amount: 15000, moodPoints: 1500},
  { amountLevel: 5, amount: 20000, moodPoints: 2000}
]
export default investmentMoodPointsDataset;